/**
 * @generated SignedSource<<bce392c1836de37b156c73695d319233>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bodId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "bodId",
    "variableName": "bodId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "documentType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dwollaStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessBeneficialOwnerDocumentFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BeneficialOwnerDocT",
        "kind": "LinkedField",
        "name": "beneficialOwnerDocTByBodId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessBeneficialOwnerDocumentFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BeneficialOwnerDocT",
        "kind": "LinkedField",
        "name": "beneficialOwnerDocTByBodId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eece470e07f7c9a82817b296a3db8407",
    "id": null,
    "metadata": {},
    "name": "BusinessBeneficialOwnerDocumentFetchQuery",
    "operationKind": "query",
    "text": "query BusinessBeneficialOwnerDocumentFetchQuery(\n  $bodId: UUID!\n) {\n  beneficialOwnerDocTByBodId(bodId: $bodId) {\n    created\n    documentType\n    dwollaStatus\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "a5d93e0239288ac46a2f960c7422cead";

module.exports = node;
